import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useWishlist } from '../../context/WishlistContext';
import { useCart } from '../../context/CartContext';
import SearchModal from '../../components/feature/SearchModal';

export default function WishlistPage() {
  const { items, removeFromWishlist, totalItems: wishlistTotal } = useWishlist();
  const { addToCart, totalItems } = useCart();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [collectionDropdownOpen, setCollectionDropdownOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);

  const handleAddToCart = (item: any) => {
    addToCart({
      productId: item.id,
      name: item.name,
      price: item.price,
      size: 'M',
      quantity: 1,
      image: item.image,
      quote: item.quote
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <SearchModal isOpen={searchModalOpen} onClose={() => setSearchModalOpen(false)} />
      
      {/* Top Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white z-50 border-b border-black/10">
        <div className="px-6 py-4 flex items-center justify-between">
          {/* Mobile: Hamburger on left */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          {/* Desktop: Menu items on left */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">NEW ARRIVALS</Link>
            <div 
              className="relative"
              onMouseEnter={() => setCollectionDropdownOpen(true)}
              onMouseLeave={() => setCollectionDropdownOpen(false)}
            >
              <button className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1">
                COLLECTION
                <i className="ri-arrow-down-s-line text-lg"></i>
              </button>
              {collectionDropdownOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="bg-white border border-black/10 py-2 min-w-[160px] shadow-lg">
                    <Link to="/shop?category=hoodies" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      HOODIES
                    </Link>
                    <Link to="/shop?category=tees" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      T-SHIRTS
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">ABOUT</Link>
          </div>

          {/* Logo in center */}
          <Link to="/" className="cursor-pointer absolute left-1/2 transform -translate-x-1/2">
            <img 
              src="https://static.readdy.ai/image/6ad45fecb24f9c50dfb1488fc3ba7d2f/1bfa6c5bfe10d7e974b284f405d55895.png" 
              alt="DASHY" 
              className="h-7 md:h-8"
            />
          </Link>
          
          {/* Icons on right */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setSearchModalOpen(true)}
              className="w-10 h-10 hidden md:flex items-center justify-center cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-heart-fill text-xl"></i>
              {wishlistTotal > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {wishlistTotal}
                </span>
              )}
            </Link>
            <Link to="/cart" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-shopping-bag-line text-xl"></i>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {totalItems}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-black/10 bg-white">
            <div className="px-6 py-4 flex flex-col gap-4">
              <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>NEW ARRIVALS</Link>
              <div>
                <button 
                  onClick={() => setCollectionDropdownOpen(!collectionDropdownOpen)}
                  className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1 w-full"
                >
                  COLLECTION
                  <i className={`ri-arrow-${collectionDropdownOpen ? 'up' : 'down'}-s-line text-lg`}></i>
                </button>
                {collectionDropdownOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    <Link to="/shop?category=hoodies" className="block text-sm tracking-[0.2em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      HOODIES
                    </Link>
                    <Link to="/shop?category=tees" className="block text-sm tracking-[0.2em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      T-SHIRTS
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>ABOUT</Link>
              <div className="flex gap-4 pt-4 border-t border-black/10">
                <button 
                  onClick={() => {
                    setSearchModalOpen(true);
                    setMobileMenuOpen(false);
                  }}
                  className="w-10 h-10 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-search-line text-xl"></i>
                </button>
                <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-heart-fill text-xl"></i>
                  {wishlistTotal > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                      {wishlistTotal}
                    </span>
                  )}
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Wishlist Content */}
      <div className="pt-32 pb-24 px-6">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-5xl font-light tracking-[0.3em] text-center mb-16" style={{ fontFamily: '"Playfair Display", serif' }}>
            MY WISHLIST
          </h1>

          {items.length === 0 ? (
            <div className="text-center py-24">
              <i className="ri-heart-line text-6xl text-neutral-300 mb-6"></i>
              <p className="text-lg tracking-[0.2em] text-neutral-600 mb-8">YOUR WISHLIST IS EMPTY</p>
              <Link 
                to="/shop"
                className="inline-block px-12 py-4 border border-black text-sm tracking-[0.3em] hover:bg-black hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                DISCOVER PRODUCTS
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {items.map(item => (
                <div key={item.id} className="group">
                  <Link to={`/product/${item.id}`} className="block cursor-pointer">
                    <div className="relative aspect-[3/4] bg-neutral-50 mb-4 overflow-hidden">
                      <img 
                        src={item.image}
                        alt={item.name}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          removeFromWishlist(item.id);
                        }}
                        className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
                      >
                        <i className="ri-heart-fill text-red-500 text-xl"></i>
                      </button>
                    </div>
                  </Link>
                  <h3 className="text-sm tracking-[0.2em] mb-2">{item.name}</h3>
                  <p className="text-xs text-neutral-500 mb-2 italic">"{item.quote}"</p>
                  <p className="text-sm mb-4">${item.price}.00</p>
                  <button
                    onClick={() => handleAddToCart(item)}
                    className="w-full py-3 bg-black text-white text-xs tracking-[0.2em] hover:bg-neutral-800 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    ADD TO CART
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black text-white py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <h3 className="text-xl font-light tracking-[0.3em] mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>DASHY</h3>
              <p className="text-sm text-neutral-400 leading-relaxed">
                Quiet luxury streetwear with meaningful messages for the modern individual.
              </p>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">SHOP</h4>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">New Arrivals</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">Hoodies</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">T-Shirts</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">COMPANY</h4>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm tracking-[0.2em] mb-4">FOLLOW US</h4>
              <div className="flex gap-4">
                <a href="https://instagram.com/Dashyfashionofficial" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 hover:bg-white hover:text-black transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-neutral-400">
            <div className="flex items-center gap-3">
              <p>© 2024 DASHY FASHION LIMITED. All rights reserved.</p>
            </div>
            <div className="flex gap-6">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
